export interface ExternalCostLimitError {
  groupId: number;
  costTypeId: number;
}

export const parseExternalCostLimitError = (message: string | null | undefined): ExternalCostLimitError | null => {
  if (!message) return null;

  const groupMatch = message.match(/gruppo (\d+)/);
  const costTypeMatch = message.match(/tipologia di costo (\d+)/);

  if (!groupMatch || !costTypeMatch) return null;

  return {
    groupId: Number(groupMatch[1]),
    costTypeId: Number(costTypeMatch[1]),
  };
};